import { createFileRoute } from '@tanstack/react-router';

import { AllRoutines } from '@/features/routines/routines-list';

export const Route = createFileRoute('/_authenticated/routines/')({
  validateSearch: (search: Record<string, unknown>): { template?: string } =>
    typeof search.template === 'string' ? { template: search.template } : {},
  component: AllRoutines,
});
